import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import KTable from '../../components/KTable';
import KPagination from '../../components/KPagination';
import {
  ApproveReimbursementDataType,
  ApproveReimbursementFilterType,
  ColumnHeaderType,
  PaginationType,
} from '../../utils/Types';
import CenterSpinner from '../../components/CenterSpinner';
import {
  API_STATUS,
  approveReimbursementFilterInit,
  DEFAULT_PAGE_SIZE,
} from '../../utils/Constant';
import {
  ApproveReimbursementColumnHeader,
  handleApproveSuccessToggle,
  handlePayloadForApproveList,
  handleToggleModal,
  onTableAction,
} from './ReimbursementHelper';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  clearApproveReimbursementDetails,
  getApproveReimbursementData,
  reimbursementSelector,
} from '../../features/reimbursementSlice';
import ApproveReimbursementFilter from '../../filters/ApproveReimbursementFilter';
import ApproveReimbursementModal from '../modals/ApproveReimbursementModal';
import SuccessfullyApprovedModal from '../modals/SuccessfullyApprovedModal';
import { useLoader } from '../../loader/LoaderProvider';

const ApproveReimbursementPage: React.FunctionComponent = () => {
  const { showLoader, setShowLoader } = useLoader();
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isSuccessfullyApproveOpen, setIsSuccessfullyApproveOpen] =
    useState(false);
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedTask, setSelectedTask] = useState<any>(null);
  const [selectedFilter, setSelectedFilter] =
    useState<ApproveReimbursementFilterType>(approveReimbursementFilterInit);
  const approveReimbursementData: ApproveReimbursementDataType[] =
    useAppSelector(reimbursementSelector).approveReimbursementData;
  const pagination: PaginationType = useAppSelector(
    reimbursementSelector
  ).approveReimbursementPagination;
  const apiStatus = useAppSelector(reimbursementSelector).apiProgressStatus;

  const getApproveReimbursementDataList = (
    filter: ApproveReimbursementFilterType
  ) => {
    const data = handlePayloadForApproveList(currentPage, pageSize, filter);
    dispatch(getApproveReimbursementData(data));
  };

  useEffect(() => {
    getApproveReimbursementDataList(selectedFilter);
  }, [currentPage, pageSize, selectedFilter]);

  useEffect(() => {
    if (apiStatus && apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [apiStatus]);

  const toggleModal = (action?: any) => {
    handleToggleModal(
      action,
      setIsSuccessfullyApproveOpen,
      setIsModalOpen,
      getApproveReimbursementDataList,
      setSelectedTask,
      selectedFilter
    );
    dispatch(clearApproveReimbursementDetails());
  };
  return (
    <div>
      <Label className="text-heading">Approve Reimbursement</Label>
      <ApproveReimbursementFilter
        onApplyFilters={(filter: ApproveReimbursementFilterType) => {
          setSelectedFilter(filter);
          setCurrentPage(1);
        }}
      />
      <div className="mt-4">
        <KTable
          data={approveReimbursementData}
          tableParentClass="table-parent-assign-grid"
          columnHeader={ApproveReimbursementColumnHeader}
          isLoading={showLoader}
          onAction={(param: any, columnHeader: ColumnHeaderType) => {
            onTableAction(param, columnHeader, setSelectedTask, setIsModalOpen);
          }}
        />
        {approveReimbursementData && approveReimbursementData.length > 0 && (
          <KPagination
            currentPage={pagination?.currentPage}
            pageSize={pagination?.pageSize}
            onPageChange={setCurrentPage}
            onSizeChange={setPageSize}
            fromItem={pagination.fromItem}
            toItem={pagination.toItem}
            totalItems={pagination?.totalItems}
          />
        )}
      </div>
      {isModalOpen && (
        <ApproveReimbursementModal
          isOpen={isModalOpen}
          toggleModal={toggleModal}
          selectedTask={selectedTask}
        />
      )}
      {isSuccessfullyApproveOpen && (
        <SuccessfullyApprovedModal
          isOpen={isSuccessfullyApproveOpen}
          toggleModal={() => {
            handleApproveSuccessToggle(
              setIsSuccessfullyApproveOpen,
              toggleModal,
              isSuccessfullyApproveOpen
            );
          }}
          reimbursementDetails={selectedTask}
        />
      )}
      <CenterSpinner showLoader={showLoader} className="spinner-60" />
    </div>
  );
};

export default ApproveReimbursementPage;
